export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -80, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

export function AppStoreButton({ label, dark = false, className = "", testId = "app-store-button" }) {
  const base = dark
    ? "bg-white text-black hover:bg-white/90"
    : "brand-gradient text-white hover:opacity-95";
  return (
    <a
      href="#download"
      data-testid={testId}
      onClick={(e) => {
        e.preventDefault();
        scrollToId("download");
      }}
      className={`focus-ring group inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-medium transition-[opacity,background-color,transform] duration-200 active:scale-95 ${base} ${className}`}
    >
      <span>{label}</span>
    </a>
  );
}

export function GhostButton({ label, onClick, dark = false, className = "", testId }) {
  const base = dark
    ? "border-white/20 text-white hover:bg-white/10"
    : "border-black/10 text-black hover:bg-black/[0.04]";
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      className={`focus-ring inline-flex items-center justify-center rounded-full border px-6 py-3.5 text-sm font-medium transition-[background-color,transform] duration-200 active:scale-95 ${base} ${className}`}
    >
      {label}
    </button>
  );
}
